import { FC, useEffect, useState } from 'react';
import { useCommunications } from '../../../../../hooks/use-communications';
import { useContactState } from '../../../../../hooks/use-contacts';
import { usePatientProfile } from '../../../../../hooks/use-patient-profile/use-patient-profile';
import CommsFilterWidget from '../../../../layout/slideout/comm-filter-widget/comms-filter-widget';
import { CommunicationsSlideout } from '../../../../layout/slideout/communications-widget';
import { CommunicationsFilters } from '../../../../layout/slideout/communications-widget/communications-filters-component';
import { CommunicationStatus } from '../../../../layout/slideout/communications-widget/communications-status-component';
import { useCommunicationsStatus } from '../../../../layout/slideout/communications-widget/use-communications-status';
import { Filters, PatientName } from '../header/contact-info/contact-info.styles';
import { ContactHeader, FilterContainer, InboxContainer } from './inbox.style';

type InboxPatientProfileProps = {
  allowReadOnly?: boolean;
};

export const InboxPatientProfile: FC<InboxPatientProfileProps> = ({ allowReadOnly }) => {
  const { contactDetails } = usePatientProfile();
  const { contactCache, loadContactsByPhoneNumbers } = useContactState();
  const [isFilteringOpened, setIsFilteringOpened] = useState(false);

  const { patientPhoneNumbers, setPatientId } = useCommunications();
  const communicationStatus = useCommunicationsStatus(patientPhoneNumbers);

  const allContacts = contactCache[contactDetails?.cellPhone as string]?.data || [];

  useEffect(() => {
    if (contactDetails?.cellPhone) {
      loadContactsByPhoneNumbers([contactDetails.cellPhone]);
      setPatientId(null);
    } else if (contactDetails?.id) {
      setPatientId(contactDetails.id);
    }
  }, [contactDetails]);

  if (!contactDetails?.cellPhone && !allowReadOnly) {
    return null;
  }

  const contactsCount = allContacts.length > 1 ? `+${allContacts.length - 1}` : '';

  return (
    <InboxContainer>
      <ContactHeader>
        <PatientName>
          {contactDetails.firstName}’s Inbox {contactsCount}
          <CommunicationStatus finalStatus={communicationStatus.finalStatus} />
        </PatientName>
        <Filters>
          <CommunicationsFilters
            {...communicationStatus}
            patientPhoneNumbers={patientPhoneNumbers}
            onClickFilter={() => {
              setIsFilteringOpened(true);
            }}
          />
        </Filters>
      </ContactHeader>
      <CommunicationsSlideout
        phoneNumber={contactDetails.cellPhone}
        patientId={contactDetails.id}
        locationId={contactDetails.location?.id}
        allowReadOnly={allowReadOnly}
      />
      {isFilteringOpened && (
        <FilterContainer>
          <CommsFilterWidget onFilterApplied={() => setIsFilteringOpened(false)} />
        </FilterContainer>
      )}
    </InboxContainer>
  );
};
